module.exports = __webpack_public_path__ + "img/selected5-min.861a6c86.png";